let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cC8RD")).then(() => parcelRequire('aRQqo'));